





































































import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import { PokemonManagementStore } from '@/store';
import { Pokemon } from '@/class';
import PokedexBrowser from '@/features/pokedex/PokedexBrowser.vue';
import ShowCards from '@/components/cards/ShowCards.vue';
import DisplayPokemon from '../pokemon-manager/DisplayPokemon.vue';
import RoleSelect from './RoleSelect.vue';
import AbilitySelect from './AbilitySelect.vue';
import SkillSelect from './SkillSelect.vue';
import MoveSelect from './MoveSelect.vue';
import NicknameSelect from './NicknameSelect.vue';

export default Vue.extend({
  name: 'pokemon-builder',
  components: {
    PokedexBrowser,
    ShowCards,
    DisplayPokemon,
    RoleSelect,
    AbilitySelect,
    MoveSelect,
    SkillSelect,
    NicknameSelect,
  },
  data: () => ({
    step: 1,
    pokemon: {},
  }),
  created() {
    this.pokemon = new Pokemon();
  },
  methods: {
    updatePokemon(variable) {
      this.pokemon = variable;
    },
    savePokemon() {
      const store = getModule(PokemonManagementStore, this.$store);
      store.AddPokemon(this.pokemon);
      this.$router.push('pokemon-manager');
    },
  },
});
